export enum LoginHelpErrorCodes {
    MULTIPLE_MATCHES_ERROR = 300,
    BAD_REQUERST = 400,
    MEMBER_DOESNT_EXIST_ERROR = 404,
    REQUESTED_SUBSCRIBER_ERROR = 405,
    MEMBER_NOT_FOUND_ERROR = 406,
    LINK_EXPIRED_ERROR = 419,
    COVERAGE_INFO_INVALID_ERROR = 422,
    DEPENDENTS_UNDERAGE_ERROR = 481,
    MULTIPLE_COVERAGES_ERROR = 482
}
